function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-61"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.38 381.71 63.38 335.34 67.35 335.34 67.35 313.24 73.14 313.24 73.14 236.42 81.52 236.42 81.52 226.51 99.41 218.17 99.41 208.17 101.89 208.17 101.89 236.42 105.36 236.42 105.36 313.24 108.83 313.24 108.83 272.85 118.25 272.85 118.25 252.03 120.87 252.03 120.87 313.24 128.03 313.24 128.03 289.95 132.74 289.95 132.74 284 143.64 284 143.64 263.68 149.61 263.68 149.61 249.31 156.95 249.31 156.95 228.37 159.57 228.37 159.57 249.31 166.91 249.31 166.91 263.68 172.88 263.68 172.88 284 183.78 284 183.78 289.95 188.49 289.95 188.49 313.24 194.08 313.24 194.08 284 204.98 284 204.98 221.06 208.45 221.06 208.45 214.12 231.74 214.12 231.74 221.06 236.7 221.06 236.7 266.65 256.52 266.65 256.52 271.12 263.96 271.12 263.96 274.58 256.52 274.58 256.52 292.43 277.34 292.43 277.34 232.95 281.8 232.95 281.8 220.31 291.47 220.31 291.47 175.46 294.19 175.46 294.19 220.31 301.13 220.31 301.13 232.95 341.81 232.95 341.81 228.79 344.29 228.79 344.29 257.04 347.76 257.04 347.76 257.54 349.84 257.54 349.84 285.79 353.31 285.79 353.31 293.47 360.64 293.47 360.64 272.66 363.27 272.66 363.27 322.22 366.2 322.22 366.2 301.4 368.82 301.4 368.82 333.87 370.42 333.87 370.42 310.57 375.13 310.57 375.13 304.62 386.04 304.62 386.04 284.3 392.01 284.3 392.01 269.93 399.35 269.93 399.35 248.99 401.96 248.99 401.96 269.93 409.31 269.93 409.31 284.3 415.28 284.3 415.28 304.62 426.18 304.62 426.18 310.57 430.89 310.57 430.89 333.37 431.73 333.37 431.73 333.87 434.06 333.87 434.06 381.71 63.38 381.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.3,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.84,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.38,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.92,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.46,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.54,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.08,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 235.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 240.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 245.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 249.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 254.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 259.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 263.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 268.69,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.62,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.4,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.94,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.01,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 265.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 223.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 228.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 232.92,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 265.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.09,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.62,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.16,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.7,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.24,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 333.2,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.77,
    y: 337.91,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 333.2,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 337.91,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 342.62,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 323.79,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 328.5,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 333.2,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 337.91,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.56,
    y: 342.62,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.1,
    y: 323.79,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.64,
    y: 323.79,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.18,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.72,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 239.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 243.74,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 248.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 253.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 257.87,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 262.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 267.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 272,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.26,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 325.19,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 358.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.03,
    y: 362.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 325.19,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.57,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 273.4,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 278.11,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 282.82,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 287.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 292.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 325.19,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.11,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 307.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 312.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 317.18,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 321.89,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 326.6,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 331.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 336.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 340.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 345.43,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 350.14,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 354.85,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 359.56,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.71,
    y: 364.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 307.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 312.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 317.18,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 321.89,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 326.6,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 331.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 336.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 340.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 345.43,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 350.14,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 354.85,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 359.56,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.25,
    y: 364.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 307.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 312.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 317.18,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 321.89,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 326.6,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 331.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 336.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 340.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 345.43,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 350.14,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 354.85,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 359.56,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 364.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.79,
    y: 368.97,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 309.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 313.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 318.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 323.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 328,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 332.71,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 337.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 342.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 346.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 351.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.01,
    y: 365.67,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 309.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 313.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 318.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 323.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 328,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 332.71,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 337.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 342.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 346.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 360.96,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.55,
    y: 365.67,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 309.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 313.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 318.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 323.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 328,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 332.71,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 337.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 342.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 356.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 360.96,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.09,
    y: 365.67,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 265.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 312.97,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 327.09,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 331.8,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 336.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.62,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 265.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 336.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.16,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 237.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 242.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 247.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 251.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 256.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 261.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 265.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 327.09,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 331.8,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.7,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 325.19,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 358.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 362.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.81,
    y: 367.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 358.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 362.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.35,
    y: 367.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 296.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 301.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 306.36,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 311.07,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 315.78,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 320.48,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 329.9,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 334.61,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 339.32,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 344.03,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 348.73,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 353.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 358.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 362.86,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.89,
    y: 367.57,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 312.97,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 327.09,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 336.51,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 345.93,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 350.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 360.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 364.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.89,
    y: 369.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 312.97,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 327.09,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 345.93,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 355.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 360.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 364.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.43,
    y: 369.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 270.59,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 275.3,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 280.01,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 284.72,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 289.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 294.13,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 298.84,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 303.55,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 308.26,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 312.97,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 317.68,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 322.38,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 327.09,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 331.8,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 341.22,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 350.63,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 355.34,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 360.05,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 364.76,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 369.47,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 297.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 302.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 306.85,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 311.56,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 316.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 320.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 335.1,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 339.81,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 344.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 349.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 353.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 358.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.06,
    y: 363.35,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 297.44,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 302.15,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 306.85,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 311.56,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 316.27,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 320.98,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 335.1,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 339.81,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 344.52,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 349.23,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 353.94,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 358.65,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.6,
    y: 368.06,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 323.79,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 333.2,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 337.91,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 342.62,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 347.33,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 352.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 356.75,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 361.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.41,
    y: 366.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 276.7,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 281.41,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 286.12,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 290.83,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 295.54,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 300.25,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 304.95,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 309.66,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 314.37,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 319.08,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 323.79,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 328.5,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 333.2,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 337.91,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 342.62,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 347.33,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 352.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 356.75,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 361.45,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.95,
    y: 366.16,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 295.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 299.75,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 304.46,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 309.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 313.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 318.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 323.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 328,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 332.71,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.38,
    y: 337.42,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 295.04,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 299.75,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 304.46,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 309.17,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 313.88,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 318.58,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 323.29,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 328,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 332.71,
    width: 2.81,
    height: 2.81,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73,104.17a3.79,3.79,0,0,0-3.79-3.79,3.55,3.55,0,0,0-1.09.16,9,9,0,0,0,.08-1.17,8,8,0,0,0-9.52-7.9,7,7,0,0,0-13,3.55h-.12a6.48,6.48,0,0,0,0,13H119A3.79,3.79,0,0,0,122.73,104.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.67,106.17h19.17a12.81,12.81,0,0,1-.08-1.39,12.63,12.63,0,0,1,12.62-12.63c.16,0,.31,0,.46,0a11.16,11.16,0,0,1,21.62,3.89v0a10.64,10.64,0,0,1,10.14,10.07h.5a5.62,5.62,0,0,1,0,11.23H351.67a5.62,5.62,0,0,1,0-11.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.69,131.19a23.32,23.32,0,0,1,39.79.34,12.47,12.47,0,0,1,15.9,12v0H290a6.25,6.25,0,0,1,0,12.5H267.2a23.33,23.33,0,0,1-36.41,3.83c-.39,0-.79.06-1.19.06a14.46,14.46,0,0,1-1.91-28.79Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-61"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-61",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.72,392s4.75-10.36-.68-20.58-7-12.63-3.54-14.72,5,8.17,5,8.17a23.11,23.11,0,0,0,.51-14.45c-2.41-7.39-3.92-19.43-.63-20.72s.62,15,3.48,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.35a137.22,137.22,0,0,0-2.53,23.76s5.64-17.19,9.42-17.69,3.78,5.06.54,9.89-9.48,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6-7.86,20.51-7.86,20.51Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,392s4.75-10.36-.68-20.58-7-12.63-3.54-14.72,5,8.17,5,8.17a23.11,23.11,0,0,0,.51-14.45c-2.41-7.39-3.92-19.43-.63-20.72s.62,15,3.48,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.35a137.22,137.22,0,0,0-2.53,23.76s5.64-17.19,9.42-17.69,3.78,5.06.54,9.89-9.48,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6-7.86,20.51-7.86,20.51Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,396.29s-4.63-10.43.92-20.57,7.15-12.52,3.72-14.66-5.15,8.1-5.15,8.1a23.1,23.1,0,0,1-.33-14.47c2.5-7.35,4.15-19.37.88-20.71s-.81,15-3.73,20.53a48.29,48.29,0,0,1-2.65-12.17c-.32-5.94.41-15.41-2.16-17.88s-4.25-.81-1.85,12.32a137.21,137.21,0,0,1,2.24,23.79s-5.43-17.27-9.2-17.82-3.84,5-.66,9.88,9.32,13.61,10.29,18.08c0,0-6-13-11.64-9.14s4.7,11.84,9.3,14.74,7.62,20.63,7.62,20.63Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.13 388.85 107.34 388.85 104.25 416.2 72.23 416.2 69.13 388.85",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.23,183.8H399.5a8.84,8.84,0,0,0-8.84,8.85v9.74l-8.89,2.76,8.89,2.76v9.74a8.84,8.84,0,0,0,8.84,8.85h28.73a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,428.23,183.8Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.23,183.8H399.5a8.84,8.84,0,0,0-8.84,8.85v9.74l-8.89,2.76,8.89,2.76v9.74a8.84,8.84,0,0,0,8.84,8.85h28.73a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,428.23,183.8Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.97,
    cy: 205.15,
    r: 14.26,
    transform: "translate(-23.81 352.81) rotate(-45)",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.48,211.52a1.31,1.31,0,0,1-1-.46l-5.6-6.59a1.31,1.31,0,0,1,2-1.7l4.6,5.41,7.59-8.94a1.31,1.31,0,1,1,2,1.7l-8.58,10.12A1.33,1.33,0,0,1,412.48,211.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.93,119.91H139.21a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h8.38l0,8.89,6-8.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,167.93,119.91Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.93,119.91H139.21a8.85,8.85,0,0,0-8.85,8.85v25a8.85,8.85,0,0,0,8.85,8.85h8.38l0,8.89,6-8.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,167.93,119.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.87,154l1,.82,1.75-1.75-.82-1a6.62,6.62,0,0,0,1-2.29l1.27-.12V147.2l-1.27-.12a6.62,6.62,0,0,0-1-2.29l.82-1-1.75-1.75-1,.82a6.62,6.62,0,0,0-2.29-.95l-.12-1.28H143l-.12,1.28a6.49,6.49,0,0,0-2.28.95l-1-.82-1.75,1.75.82,1a6.62,6.62,0,0,0-.95,2.29l-1.27.12v2.47l1.27.12a6.62,6.62,0,0,0,.95,2.29l-.82,1,1.75,1.75,1-.82a6.49,6.49,0,0,0,2.28.95l.12,1.28h2.47l.12-1.28A6.62,6.62,0,0,0,147.87,154Zm-7-5.56a3.35,3.35,0,1,1,3.35,3.35A3.35,3.35,0,0,1,140.88,148.43Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.86,146.13l1.43,1.18,2.52-2.52-1.18-1.43a9.54,9.54,0,0,0,1.37-3.3l1.84-.17v-3.58l-1.84-.17a9.54,9.54,0,0,0-1.37-3.3l1.18-1.43-2.52-2.53-1.43,1.19a9.56,9.56,0,0,0-3.3-1.38l-.18-1.84h-3.57l-.17,1.83a9.56,9.56,0,0,0-3.3,1.38l-1.43-1.19-2.53,2.53,1.19,1.43a9.56,9.56,0,0,0-1.38,3.3l-1.84.17v3.58l1.84.17a9.56,9.56,0,0,0,1.38,3.3l-1.19,1.43,2.53,2.52,1.43-1.18a9.35,9.35,0,0,0,3.3,1.37l.17,1.84h3.57l.18-1.84A9.35,9.35,0,0,0,164.86,146.13Zm-10.1-8a4.84,4.84,0,1,1,4.84,4.84A4.84,4.84,0,0,1,154.76,138.1Z",
    style: {
      fill: "#ff6200"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.12,215.51c8.41,1.88,25.56,21.11,25.56,21.11l31,3.11.33,7.32s-30.32.61-34.24.24-22.62-14.91-22.62-14.91Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,247.05s-30.31.6-34.23.24c-2-.18-7.65-3.93-12.83-7.63-2.63-1.87-5.13-3.74-6.95-5.11s-2.84-2.17-2.84-2.17V215.5c8.41,1.89,25.55,21.12,25.55,21.12l31,3.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,246.75l9.21-.7-1.89-7.85s-6.51-.42-8.77,4.46Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.77 242.53 214.96 237.02 210.32 238.2 212.21 246.05 217.77 242.53",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.91,239.66c-2.63-1.87-5.13-3.74-6.95-5.11a15.48,15.48,0,0,1-.7-6.61S155.66,232.93,156.91,239.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.21,408.18l-8.41.13a.62.62,0,0,0-.58.49L119,415a1,1,0,0,0,.81,1.2l.22,0c2.72-.09,4.7-.29,8.12-.34,2.1,0,8.45.08,11.35,0s3.24-2.92,2.05-3.17c-5.35-1.08-9.39-2.62-11.12-4.13A1.69,1.69,0,0,0,129.21,408.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,408.18l-8.41.13a.62.62,0,0,0-.58.49L189.82,415a1,1,0,0,0,.81,1.2l.23,0c2.72-.09,4.69-.29,8.11-.34,2.1,0,8.45.08,11.36,0s3.23-2.92,2-3.17c-5.35-1.08-9.39-2.62-11.12-4.13A1.67,1.67,0,0,0,200.08,408.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,408.61h11.45s14.58-48.06,15.84-60.32,1.71-43,1.71-43v0l0,.05c.49.66,4.82,6.75,9.8,13.81,6.51,9.26,14.15,20.2,15.75,22.88,4.73,7.89,16.29,66.54,16.29,66.54h11.44s-2.88-52.49-8.76-69.79-31.3-55.08-32.4-57.12c-1.41-2.58-4.87-10.8-4.87-10.8l-34.31,4.76s.44,5.81.48,10.89c.16,19.06,6.76,44.83,7.34,51.75C129.81,351.47,118.92,408.61,118.92,408.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.12,215.51s10.27,18.32,8.09,55.38l-34.3,4.78c-1-5.24-1.24-31.39-9.77-55.49a90.31,90.31,0,0,1,11.29-3.05,128.56,128.56,0,0,1,14.58-2A65.28,65.28,0,0,1,147.12,215.51Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.21,270.89l-27.67,3.85-6.63.92c-.6-3.2-.93-14.27-3.06-27.91,0-.29-.09-.59-.14-.89-.6-3.75-1.34-7.68-2.26-11.69a139.58,139.58,0,0,0-4.31-15,91.39,91.39,0,0,1,11.28-3,126.59,126.59,0,0,1,14.59-2,66.76,66.76,0,0,1,10.11.41S157.38,233.82,155.21,270.89Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78,220.18l8.24,3.91,1.85,2.25s2.94,15.32,2.63,27.32l3.12,2.77,2.37-4.62s-4.9-21.59-6.48-26l.42-2.84,1.45-6-13.08.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.65,201.44c1.71,4.51,4.08,12.91,1.35,16.59,4.8,1.13,8.24,1.87,12.62,4.63.86-3.1,1.89-7.11,1.89-7.11-5.42-.35-5.94-4.24-5.65-8Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.81,203.92l6,3.6a15.65,15.65,0,0,0,0,2.65c-2,.06-5.14-1.66-5.71-3.71A7.07,7.07,0,0,1,125.81,203.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.92,408.61h11.45s14.58-48.06,15.84-60.32,1.71-43,1.71-43v0l0,.05c.49.66,4.82,6.75,9.8,13.81,6.51,9.26,14.15,20.2,15.75,22.88,4.73,7.89,16.29,66.54,16.29,66.54h11.44s-2.88-52.49-8.76-69.79-31.3-55.08-32.4-57.12c-1.41-2.58-4.87-10.8-4.87-10.8l-34.31,4.76s.44,5.81.48,10.89c.16,19.06,6.76,44.83,7.34,51.75C129.81,351.47,118.92,408.61,118.92,408.61Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.14 218.09 120.99 214.54 130.22 216.32 134.91 221.69 135.5 215.49 137.23 213.41 141.02 215.05 141.02 218.93 138.32 218.05 135.99 223.46 128.61 220.43 126.97 222.52 118.14 218.09",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.14 218.09 120.99 214.54 130.22 216.32 134.91 221.69 135.5 215.49 137.23 213.41 141.02 215.05 141.02 218.93 138.32 218.05 135.99 223.46 128.61 220.43 126.97 222.52 118.14 218.09",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.99 223.46 136.88 216.98 141.02 218.93 138.32 218.05 135.99 223.46",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.99 223.46 129.15 218.44 126.97 222.52 128.61 220.43 135.99 223.46",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92,305.31v0l0,.05c.49.66,4.82,6.75,9.8,13.81a19.57,19.57,0,0,0-9.65-19.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,185.48c2,1.71,2.3,4.74,2.67,6.65s1.08,4.36-1.79,2.09S127.5,181.45,133.68,185.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63,196.71c1.81,6.29,1.12,7.51,5.06,10,5.94,3.81,14.08,3,13.81-3.69-.25-6.05-2-16.72-8.78-17.82A9,9,0,0,0,119.63,196.71Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.24,200.88c3.36-.62,2.68-1.9,2.44-2.19-1.09-1.25-.43-3.43.22-6.23s-5.1-5-8.77-3.32C111.74,190.73,115.61,201.93,121.24,200.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,201.61a6,6,0,0,0,3.62,2.47c1.87.36,2.45-1.51,1.63-3.34-.74-1.65-2.6-3.82-4.33-3.35S116.56,200,117.66,201.61Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.16,194.59a15.33,15.33,0,0,0,2.71,3.18,2.51,2.51,0,0,1-1.93.79Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.61,186.38c1-2.37,12.12-5.9,16.88-5a2.94,2.94,0,0,1,2.62,3.75c-1.51,4.57-5.44,2.8-5.44,2.8a5.25,5.25,0,0,0-7,2.62l-6.88-.59A3.67,3.67,0,0,1,114.61,186.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.6,195c.11.54.48.91.83.84s.55-.57.44-1.11-.49-.91-.84-.83S128.49,194.48,128.6,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.66,193.7c.11.54.49.91.84.84s.54-.58.43-1.11-.48-.91-.83-.84S134.55,193.16,134.66,193.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3,193.62a.33.33,0,0,0,.27-.19,2.58,2.58,0,0,1,1.8-1.49.33.33,0,0,0,.28-.37.33.33,0,0,0-.36-.27,3.22,3.22,0,0,0-2.3,1.86.32.32,0,0,0,.15.43A.45.45,0,0,0,125.3,193.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.82,191.2a.27.27,0,0,0,.17-.06.32.32,0,0,0,.06-.46,3.17,3.17,0,0,0-2.63-1.28.32.32,0,0,0-.29.35.31.31,0,0,0,.34.29,2.46,2.46,0,0,1,2.07,1A.32.32,0,0,0,135.82,191.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,201.85a7,7,0,0,1-3.35-.79.27.27,0,0,1-.1-.35.25.25,0,0,1,.34-.09,7.2,7.2,0,0,0,4.25.64.25.25,0,0,1,.29.2.24.24,0,0,1-.2.29A6.74,6.74,0,0,1,133.72,201.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.54,274.74l-6.63.92c-.6-3.2-.93-14.27-3.06-27.91,2.36-6.28,4.64-11.05,4.64-11.05a89,89,0,0,1,12,15.9C138.58,259.46,134.54,269.83,127.54,274.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.64 110.41 342.19 112.54 347.26 119.92 351.47 125.53 263.9 191.19 221.62 185.15 98.49 277.48 103.55 284.85 121.55 308.86 234.74 223.98 277.02 230.03 374.83 156.69 384.4 169.46 401.7 117.79 396.64 110.41",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.64 110.41 342.19 112.54 347.26 119.92 351.47 125.53 263.9 191.19 221.62 185.15 98.49 277.48 103.55 284.85 121.55 308.86 234.74 223.98 277.02 230.03 374.83 156.69 384.4 169.46 401.7 117.79 396.64 110.41",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.64 110.41 342.19 112.54 351.76 125.31 263.9 191.19 221.62 185.15 98.49 277.48 116.48 301.48 229.68 216.6 271.95 222.65 369.76 149.31 379.34 162.08 396.64 110.41",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.64 110.41 342.19 112.54 351.76 125.31 263.9 191.19 221.62 185.15 98.49 277.48 116.48 301.48 229.68 216.6 271.95 222.65 369.76 149.31 379.34 162.08 396.64 110.41",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.72,264.11l8.24,4.18-4.76,6.53s-6.17-2.12-6.39-7.49Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.74 273.67 165.03 277.69 161.2 274.82 165.96 268.29 169.74 273.67",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,220.18c-9,5.59,6,34.84,8.86,39.21s34.81,11.51,34.81,11.51l3.95-6.79-29.7-13.2L120,228.21C116.48,221,111.14,220.18,111.14,220.18Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,220.18c-9,5.59,6,34.84,8.86,39.21s34.81,11.51,34.81,11.51l3.95-6.79-29.7-13.2L120,228.21C116.48,221,111.14,220.18,111.14,220.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "380.29 414.63 386.47 412.07 382.3 397.05 376.12 399.61 380.29 414.63",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,402l-11.73,4.86s-10.38-38.31-20.38-58.05c-5.49-10.82-14.84-28-23-42.68-4-7.28-7.72-13.94-10.51-18.93-3.06-5.49-5-8.95-5-8.95l19.86-13.37s26.85,53.67,34.88,72.36C379.45,357.71,386.52,402,386.52,402Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,408.6h-8.15a.59.59,0,0,0-.57.46L375.94,415a1,1,0,0,0,1,1.18c2.62,0,4.54-.2,7.84-.2,2,0,8.15.22,11,.22s3.2-2.78,2.05-3c-5.14-1.13-9-2.68-10.63-4.16A1.6,1.6,0,0,0,386,408.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.45,306.13c-4-7.28-7.72-13.94-10.51-18.93a6.8,6.8,0,0,1,4.29.84A36.73,36.73,0,0,1,331.45,306.13Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52,176.47l5-7.77-7.4-3.22s-4.26,4.93-1.73,9.68Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.07 162.15 361.97 161.06 360.12 165.47 367.52 168.7 368.07 162.15",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.91,233.71c13.58-11.16,20.68-18.56,23.4-23S364,174.48,364,174.48l-7.82.36,3.55,31.35-12,9.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,210.72c-2.46,4-8.45,10.38-19.53,19.76q-1.85,1.56-3.88,3.23l-.06-5.82-.12-11.83,12-9.87-3.56-31.35,7.83-.36S374,206.28,371.32,210.72Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.79,230.48q-1.85,1.56-3.88,3.23l-.06-5.82A18.78,18.78,0,0,1,351.79,230.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.78 413.89 287.32 415.26 292.36 400.51 285.82 399.13 280.78 413.89",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.12,265.43S321,324.89,317,344.84c-4.31,21.86-23.48,62.4-23.48,62.4l-12.42-2.61s13.06-37.47,15.95-59.42c3.23-24.53,8.08-80,8.08-80Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.7,408.6h-8.15a.59.59,0,0,0-.57.46L279.6,415a1,1,0,0,0,1,1.18c2.62,0,4.54-.2,7.84-.2,2,0,8.16.22,11,.22s3.2-2.78,2.05-3c-5.13-1.13-9-2.68-10.63-4.16A1.6,1.6,0,0,0,289.7,408.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.83,264.17c7.79-27.91,4.23-43.39,4.23-43.39a67.53,67.53,0,0,0-8.26-2.26c-.59-.13-1.19-.23-1.8-.33a128.37,128.37,0,0,0-14.85-1.09c-.93,0-1.87,0-2.79,0a28.94,28.94,0,0,0-8.78,1.7,131.49,131.49,0,0,1-1.05,20.4c-.59,5-.36,9.82-1.16,14.14-.76,4.07-.53,7.73-1.22,10.83Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.83,264.17c7.79-27.91,4.23-43.39,4.23-43.39a67.53,67.53,0,0,0-8.26-2.26c-.59-.13-1.19-.23-1.8-.33a128.37,128.37,0,0,0-14.85-1.09c-.93,0-1.87,0-2.79,0a28.94,28.94,0,0,0-8.78,1.7,131.49,131.49,0,0,1-1.05,20.4c-.59,5-.36,9.82-1.16,14.14-.76,4.07-.53,7.73-1.22,10.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.91,226.62a95.07,95.07,0,0,1,1.76,16.52c-.65,1.33-1.52,4.57-2.3,5.88-.57-1.5-1.57-4.59-2.25-6.1.61-6.52,1.76-13,1.41-16.47Z",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.42,225.46a14.68,14.68,0,0,1-9.56-7.67,7,7,0,0,0,2.65-2.58,25.12,25.12,0,0,0,3-8,49.41,49.41,0,0,0,.8-4.9l3,4.8,3.33,5.25a18,18,0,0,0-1.31,2.48c-1,2.42-.95,4.75,2,6.54C336.73,223.18,336.37,226.57,332.42,225.46Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.5 228.68 335.21 225.63 333.04 224.26 331.12 225.06 333.5 228.68",
    style: {
      fill: "#ff6200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,224.26s-1.84,1.73-3.93,3.39c-2.46-1.8-8.17-6.5-7.41-10a3.52,3.52,0,0,1,1.94-1.4A38.64,38.64,0,0,0,333,224.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,224.26a18.56,18.56,0,0,1,2.91,4.37c2.12-1.07,1.36-8,.74-8.86a8,8,0,0,0-2.93-2.48A10.91,10.91,0,0,1,333,224.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,285.54l24.79,2.5,4.29-10.14,4.07,9.2,11.16-3.54-5.85-11.72c11.19-27.2,7.23-55.78,7.23-55.78-5.08,1.23-11.17,2.05-11.17,2.05,6.5,9.88-3.19,30.91-3.19,30.91-5.83-16.24-12.8-31.93-12.8-31.93a34.44,34.44,0,0,0-12.75,3s1.18,33.23-2.18,42.64S302,285.54,302,285.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.51,271.84l5.84,11.72-11.16,3.54-4.07-9.19L326.83,288,302,285.54s.25-13.43,3.6-22.84c1.07-3,1.68-8.39,2-14.36.29-5,.37-10.44.37-15.18,0-7.37-.2-13.09-.2-13.09a34.33,34.33,0,0,1,12.75-3s7,15.69,12.8,31.93c0,0,9.7-21,3.19-30.9,0,0,6.1-.83,11.17-2.06C347.73,216.06,351.7,244.64,340.51,271.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.37,230.52l-5.44,6.85s12.72,9.1,16.45,24.22l-1.33-8.83,10.45-14.68-4.81-6,5.72-4.24s-4.92-8.28-8.85-9.72c6.5,9.88-3.19,30.91-3.19,30.91-5.83-16.24-12.8-31.93-12.8-31.93a22.38,22.38,0,0,0-7.08,10.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.65,212.38a18,18,0,0,0-1.31,2.48,11.66,11.66,0,0,1-8.83.35,25.12,25.12,0,0,0,3-8c1.27-.09,2.57-.12,3.84-.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.33,193c-1.21,2.37-1.63,7.57,2.13,6.48S325.39,188.89,323.33,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.75,199.33c-.69,6.48-.76,10.31-4.2,13.47-5.16,4.75-13.06,1.34-14.33-5.24-1.14-5.91.18-15.52,6.66-17.76A9,9,0,0,1,340.75,199.33Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,193.5,338.93,191,337.52,195l.47-.1s-1.36,5.94,1.34,9C344.88,201.76,347.92,196.58,345.76,193.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,204.86a6.12,6.12,0,0,1-3.21,3.45c-2,.87-3.3-.83-3-2.87.25-1.84,1.58-4.5,3.7-4.52A2.81,2.81,0,0,1,343,204.86Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.8,200.61c0,.53-.33.95-.67.93s-.61-.47-.59-1,.33-.94.67-.92S330.82,200.08,330.8,200.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.81,200.29c0,.53-.33.94-.67.92s-.61-.46-.59-1,.33-.94.67-.93S324.83,199.76,324.81,200.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7,200.65a18.28,18.28,0,0,1-2.77,4.23,3.13,3.13,0,0,0,2.5.56Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.18,207.62a5.24,5.24,0,0,1-.69,0,.16.16,0,1,1,0-.31,4.19,4.19,0,0,0,3.5-1.45.16.16,0,0,1,.22,0,.16.16,0,0,1,0,.22A4.3,4.3,0,0,1,329.18,207.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.73,198.78a.32.32,0,0,1-.29-.14,2.48,2.48,0,0,0-1.94-1.14.32.32,0,0,1-.32-.31.3.3,0,0,1,.3-.31A3.09,3.09,0,0,1,333,198.3a.31.31,0,0,1-.08.43A.3.3,0,0,1,332.73,198.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.32,198.09a.39.39,0,0,1-.18,0,.31.31,0,0,1-.12-.42,3.06,3.06,0,0,1,2.31-1.63.33.33,0,0,1,.34.29.31.31,0,0,1-.29.33,2.38,2.38,0,0,0-1.81,1.31A.35.35,0,0,1,322.32,198.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,197a3.49,3.49,0,0,1-.51.17,2.91,2.91,0,0,1-2.71-.72C335,195.07,336,190,330.3,191a3,3,0,0,0-3.26.13c-1.74,1.15-2.61,7.06-5.06,5.45s-1.73-2.3-1.73-2.3.61.71,1.17.47a2.66,2.66,0,0,1,.14-3s.42,1,.9,1a11.91,11.91,0,0,1,2.84-6.54c2.76-3.4,12,.42,12,.42s1.83-1.63,5.71,1.11,4.23,8.54,2.85,10.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,233.71s-.21,9.25-3.89,14.63c.29-5,.37-10.44.37-15.18A5,5,0,0,1,311.54,233.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.37,231.83l-9.16-1.22,2.33-7.73s6.52,0,8.51,5Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.86 226.79 261.98 221.44 266.54 222.88 264.21 230.62 258.86 226.79",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,233.71s-13.62,19.67-18.63,21.09S270,232,270,232l4.47-6.44,18.21,15.91s9.48-17.2,15.18-21.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,233.71s-13.62,19.67-18.63,21.09S270,232,270,232l4.47-6.44,18.21,15.91s9.48-17.2,15.18-21.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRafiki);
export default __webpack_public_path__ + "static/media/arrow-rafiki.b049dab8898941b5726d61c1bc0d9219.svg";
export { ForwardRef as ReactComponent };